export default "__VITE_ASSET__DIrBrEmd__"